import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const AlgemeneVoorwaarden = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Algemene Voorwaarden"
        description="Algemene voorwaarden KS Care. Informatie over zorgovereenkomst, financiering via WLZ/WMO/Jeugdwet en annulering."
        keywords="algemene voorwaarden, voorwaarden, zorgovereenkomst, annulering, aansprakelijkheid"
        
      />
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h1 
              className="text-4xl md:text-5xl font-bold text-[#1A4D4D] mb-6"
              style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}
            >
              Algemene Voorwaarden
            </h1>
            <p className="text-gray-600">Laatst bijgewerkt: december 2024</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto prose prose-lg">
            
            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 1 - Definities</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li><strong>KS Care:</strong> de zorgaanbieder, gevestigd te Nieuwstadt, KVK 85306452</li>
                <li><strong>Cliënt:</strong> de persoon die zorg ontvangt</li>
                <li><strong>Opdrachtgever:</strong> de ouder(s)/verzorger(s) die de zorgovereenkomst aangaan</li>
                <li><strong>Zorgovereenkomst:</strong> de overeenkomst tussen KS Care en opdrachtgever</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 2 - Toepasselijkheid</h2>
              <p className="text-gray-600 leading-relaxed">
                Deze algemene voorwaarden zijn van toepassing op alle overeenkomsten tussen KS Care en de opdrachtgever betreffende dagbesteding en/of logeeropvang.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 3 - Zorgovereenkomst</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                3.1 De zorgovereenkomst komt tot stand na een intakegesprek en schriftelijke bevestiging door beide partijen.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                3.2 In de zorgovereenkomst worden vastgelegd: de aard en omvang van de zorg, de dagen/tijden, de financiering en specifieke afspraken.
              </p>
              <p className="text-gray-600 leading-relaxed">
                3.3 Wijzigingen in de zorgovereenkomst worden schriftelijk vastgelegd.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 4 - Financiering</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                4.1 De zorg kan gefinancierd worden via WLZ (Wet langdurige zorg), WMO en Jeugdwet.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                4.2 De opdrachtgever is verantwoordelijk voor het tijdig aanvragen en in stand houden van het benodigde budget.
              </p>
              <p className="text-gray-600 leading-relaxed">
                4.3 Tarieven worden vooraf schriftelijk overeengekomen en jaarlijks geïndexeerd.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 5 - Annulering en Afzegging</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                5.1 Annulering van dagopvang dient minimaal 24 uur van tevoren te gebeuren.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                5.2 Annulering van logeeropvang dient minimaal 48 uur van tevoren te gebeuren.
              </p>
              <p className="text-gray-600 leading-relaxed">
                5.3 Bij ziekte van de cliënt vervalt de betalingsverplichting, mits tijdig gemeld.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 6 - Aansprakelijkheid</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                6.1 KS Care is verzekerd tegen beroepsaansprakelijkheid.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                6.2 KS Care is niet aansprakelijk voor schade aan of verlies van persoonlijke eigendommen van de cliënt, tenzij er sprake is van grove nalatigheid.
              </p>
              <p className="text-gray-600 leading-relaxed">
                6.3 De opdrachtgever vrijwaart KS Care voor aanspraken van derden.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 7 - Beëindiging</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                7.1 De zorgovereenkomst kan door beide partijen worden opgezegd met inachtneming van een opzegtermijn van één maand.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                7.2 KS Care kan de overeenkomst met onmiddellijke ingang beëindigen indien de veiligheid van de cliënt, andere cliënten of medewerkers in het geding is.
              </p>
              <p className="text-gray-600 leading-relaxed">
                7.3 Bij beëindiging vindt een eindevaluatie plaats.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 8 - Klachten</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                8.1 Klachten kunnen mondeling of schriftelijk worden ingediend bij KS Care.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                8.2 Wij streven ernaar klachten binnen 2 weken af te handelen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                8.3 Indien de klacht niet naar tevredenheid wordt opgelost, kan de opdrachtgever zich wenden tot een onafhankelijke klachtencommissie.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 9 - Privacy</h2>
              <p className="text-gray-600 leading-relaxed">
                KS Care verwerkt persoonsgegevens conform de AVG. Zie onze <a href="/privacy" className="text-[#FF6347] hover:underline">privacyverklaring</a> voor meer informatie.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-[#1A4D4D] mb-4">Artikel 10 - Contact</h2>
              <div className="p-4 bg-gray-50 rounded-xl">
                <p className="text-gray-700"><strong>KS Care</strong></p>
                <p className="text-gray-600">Delweide 34</p>
                <p className="text-gray-600">6118 AH Nieuwstadt</p>
                <p className="text-gray-600">KVK: 85306452</p>
                <p className="text-gray-600">Tel: 06-19199023</p>
                <p className="text-gray-600">Email: info@kscare.nl</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AlgemeneVoorwaarden;
